import React, { useContext } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import LiteratureCoverLetter from '../../../LiteratureCoverLetter';
import TextualContent from '../../TextualContent';
import { useDeviationViewContext, MobileContext } from '../../../Context';
import AutoSizedText from '../_partials/AutoSizedText';
import FolderPaywall from '../_partials/FolderPaywall';
import { normalizePremiumFolderData } from '../../../utils/normalizePremiumFolderData';
import PremiumIconWithPopover from '../_partials/PremiumIconWithPopover';
import s from './Literature.scss';
var LiteratureFullView = function (_a) {
    var title = _a.deviation.title, deviation = _a.deviation, width = _a.width, height = _a.height;
    var t = useTranslation().t;
    var isMobile = useContext(MobileContext);
    var _b = useDeviationViewContext(), isFullscreen = _b.isFullscreen, isTheater = _b.isTheater;
    var style = (isTheater || isFullscreen) && !isMobile ? { width: width, height: height } : { width: width };
    var _c = normalizePremiumFolderData(deviation === null || deviation === void 0 ? void 0 : deviation.premiumFolderData), isPremium = _c.isPremium, isPaidFolder = _c.isPaidFolder, isPremiumLocked = _c.isPremiumLocked;
    var isFullscreenLocked = isPremiumLocked && isFullscreen;
    return (React.createElement("div", { className: classnames(s['root'], isTheater && s['theater'], isFullscreen && s['fullscreen'], isFullscreenLocked && s['premium-blocked']), style: style }, isFullscreenLocked ? (React.createElement(FolderPaywall, { deviation: deviation, width: 628, height: 650 })) : (React.createElement(React.Fragment, null,
        React.createElement("div", { className: s['letter-wrap'] },
            React.createElement("div", { className: s['letter'] },
                React.createElement(LiteratureCoverLetter, { alignment: "start", title: title }))),
        React.createElement("div", { className: s['content-wrap'] },
            React.createElement("div", { className: s['title-wrap'] },
                React.createElement("div", { className: s['tag'] },
                    isPremium && (React.createElement(PremiumIconWithPopover, { className: s['premium-icon'], isPaidFolder: isPaidFolder })),
                    t('common.literature')),
                React.createElement(AutoSizedText, { className: s['title'], tooBigClassName: s['better-fit'], maxHeight: 180 }, title)),
            isFullscreen && (React.createElement(TextualContent, { deviation: deviation, withArtist: false })))))));
};
LiteratureFullView.displayName = 'LiteratureFullView';
export default LiteratureFullView;
//# sourceMappingURL=Literature.js.map